import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EventsService } from 'angular4-events';
import { DataService } from '../data.service';
import { ChatModalComponent } from "./../modals/chat-modal/chat-modal.component";
declare var $ ;
declare var moment: any;
declare var toastr: any;
declare var Nanobar: any;
@Component({
  selector: 'app-report-problem',
  templateUrl: './report-problem.component.html',
  styleUrls: ['./report-problem.component.css']
})
export class ReportProblemComponent implements OnInit {
  nao = new Nanobar();
  loadingData = false;
  internal_comments :any;
  external_comments :any;
  min_date: any = "";
  max_date: any = "";
  indexOf: number= -1;
  indexOfResolved :number = -1;
  type:any;
  BusinessFilterString: string = "All-Businesses";
  searchBusiness: string = "";
  searchTimeOut: any;
  searchBusinessDetailforOrder: any;
  business_list: number[] = [];
  businessNames: any = [];
  imageForPopup = new Array();
  checkPopupOpenFlag: boolean = true;
  options = [{
     name: "driver",id : 1
  },
  {name:'customer',id : 2},
  {name: 'business' , id:3},
  {name: 'bbm admin' , id:4}
]
resolvedOptions= [{
  name: "driver",id : 1
},
{name:'customer',id : 2},
{name: 'business' , id:3},
{name: 'bbm admin' , id:4}
]
selectedOption: any;
selectedOptions :any;
problemsList :any
issue_id :number;
restErrorCode :any
success:any;
btnDisable :boolean = true;
error_count : number;
  constructor(private dataService:DataService,  public modalService: NgbModal ,  private events: EventsService,) { }

  ngOnInit(){
    this.searchSpecificBusiness();
    this.getAllProblems();

  }
  commentsModal(id:number){
    this.nao.go(100)
    debugger
    this.issue_id = id;
 $('#comments_modal').modal('show');
  }

  confirmationModal(){
    $('#confirmation_modal').modal('show');
  }
  showRangePicker: boolean = false;
  customDateFilter(event) {
    console.log(event);
    this.min_date = moment(event[0]).format("YYYY-MM-DD");
    this.max_date = moment(event[1]).format("YYYY-MM-DD");
  }

  updateData(type) {
    if (type === "until-today") {
      this.type = 0;
    }
    if (type === "today") {
      this.type = 1;
    }
    if (type === "weekly") {
      this.type = 2;

    }
    if (type === "monthly") {
      this.type = 3;

    }
    if (type === "90Days") {
      this.type = 4;

    }
    if (type === "custom") {
      this.type = 5;
      this.showRangePicker = true;
    }
    if (this.type != 5) {
      this.showRangePicker = false;
      this.min_date = "";
      this.max_date = "";
    }
  }

  searchSpecificBusiness() {
    clearTimeout(this.searchTimeOut);
    this.searchTimeOut = setTimeout(() => {
      debugger
      this.dataService
        .getdispensaryListingById(
          localStorage.getItem("token"),
          "",
          this.searchBusiness
        )
        .subscribe(
          (data) => {
            this.searchBusinessDetailforOrder = data;
          },
          (error) => {
            console.log("error", error);
            toastr.error("Some thing went wrong");
          }
        );
    });
  }

  ApplyBusinessFilter(dispensary_id, dispensary_name, event) {
    if (dispensary_id == -1) {
      this.business_list = [];
    } else {
      let checked = event.target.checked;
      if (checked) {
        this.business_list.push(dispensary_id);
        this.businessNames.push(dispensary_name);
      } else {
        this.business_list.splice(
          this.business_list.lastIndexOf(dispensary_id),
          1
        );
        this.businessNames.splice(
          this.businessNames.lastIndexOf(dispensary_name),
          1
        );

        dispensary_name = this.businessNames[this.businessNames.length - 1];
      }
    }
    if (this.business_list.length) {
      if (this.business_list.length == 1) {
        this.BusinessFilterString = dispensary_name;
      } else if (this.business_list.length == 2) {
        this.BusinessFilterString =
          dispensary_name + " & " + (this.business_list.length - 1) + " other";
      } else if (this.business_list.length > 2) {
        this.BusinessFilterString =
          dispensary_name + " & " + (this.business_list.length - 1) + " others";
      }
    } else {
      this.BusinessFilterString = "All-Businesses";
    }

  }

  selectOption(option: any, index: number) {

    this.indexOf = index
    this.selectedOption = option.id;
  }
  selectOptions(option: any, index: number) {
    this.indexOfResolved = index
    this.selectedOptions = option.id;

  }

  getAllProblems(){
    this.dataService.getProblemListing(window.localStorage.getItem('token')).subscribe(( data:any) =>{
      this.problemsList = data.items;
    })
  }

  openImgPopup(image) {
    this.imageForPopup = image;
    console.log("image", image);
    $("#openImgModal").modal("show");
  }
  closeModal() {
    $("#openImgModal").modal("hide");
  }
  openMessagePopup(data, index) {
    debugger
    data.unread_messages_count = 0;
    this.checkPopupOpenFlag = false;
    const modalRef = this.modalService.open(ChatModalComponent, {
      centered: true,
      windowClass: "in",
      backdropClass: "in",
      backdrop: "static",
    });
    modalRef.componentInstance.data = data;
    modalRef.componentInstance.order = 1;
    modalRef.componentInstance.modalClose.subscribe((receivedEntry) => {
      this.checkPopupOpenFlag = receivedEntry;
      console.log(receivedEntry);
      this.getUnreadMessagesCountForOrders();
    });
  }

  unReadMessagesCount: any = [];
  getUnreadMessagesCountForOrders() {
    let param_data = {
      auth_token: localStorage.getItem("token"),
    };
    this.dataService.getUnreadMessagesCount(param_data).subscribe(
      (data: any) => {
        this.nao.go(100);
        if (data.unread_messages_count) {
          this.unReadMessagesCount = data.unread_messages_count;
        } else {
          toastr.error("Something went wrong!");
        }
      },
      (error) => {
        toastr.error("Something went wrong!");
      }
    );
  }

  showProblemDetails(dataid) {
    debugger
    this.dataService.setId(dataid);
    var scroll = $(window).scrollTop();
    var data = { id: dataid, page: "customerLis", scroll: scroll };
    this.events.publish("customerId", data);
    $(".all-issue").css("display", "none");
    setTimeout(() => {
      $(".issue-detail").css("display", "block");
    });
  }
  resetAll(){
    this.internal_comments = '';
    this.external_comments = '';
    this.selectedOptions = '';
    this.selectedOption = '';
    this.issue_id = null;
  }


  resolvedProblem(){
    this.error_count = 0;
    $('.c-label label').css('color', '#3d3e3d');
     $('.uploadText').css('color', '#3d3e3d');
     $('.c-label input').css('border-color', '#ccc');
     $('.c-label textarea').css('border-color', '#ccc');




     if (this.internal_comments === '' || this.internal_comments === undefined) {
                  $('#c-fname label').css('color', '#a10a0d');
                  $('#c-fname input').css('border-color', '#a10a0d');
                  toastr.error('Add Internal Comments')
                  this.error_count ++;
      }
      if (this.external_comments === '' || this.external_comments === undefined) {
                  $('#c-lname label').css('color', '#a10a0d');
                  $('#c-lname input').css('border-color', '#a10a0d');
                  toastr.error('Add External Comments');
                  this.error_count ++;
      }
      if (this.selectedOptions === '' || this.selectedOptions === undefined ) {
                  $('#c-phone label').css('color', '#a10a0d');
                  $('#c-phone input').css('border-color', '#a10a0d');
                  toastr.error('Please select favour of')
                  this.error_count ++;
      }
      if (this.selectedOption === '' || this.selectedOption === undefined) {
                  $('#c-dob label').css('color', '#a10a0d');
                  $('#c-dob input').css('border-color', '#a10a0d');
                  toastr.error('Please select against of ')
                  this.error_count ++;
      }






      if (this.error_count > 0) {
        this.btnDisable = true
        return;
      }

    this.nao.go(30);
    this.btnDisable = true;

    this.dataService.resolvedProblem(window.localStorage.getItem('token'),this.issue_id,this.internal_comments,this.external_comments, this.selectedOptions,this.selectedOption ).subscribe((data:any) =>{
      this.nao.go(100);
        this.restErrorCode = data;
        this.restErrorCode = this.restErrorCode.rest_error_code;
        this.success = data;
        this.success = this.success.success;
        if (this.restErrorCode === 1) {
          toastr.error('Some thing went wrong');
          this.btnDisable = false;
        }
        if (this.restErrorCode === 2) {
          toastr.error('Please login again');
          this.btnDisable = false;
        }
        if (this.restErrorCode === 3) {
          toastr.error('');
          this.btnDisable = false;
        }
        if (this.restErrorCode === 4) {
          toastr.error('');
          this.btnDisable = false;
        }
        if (this.success === true) {
          this.btnDisable = false;
           toastr.success('Issue resolved successfully');
           this.resetAll();
           $('#confirmation_modal').modal('hide');
           $('#comments_modal').modal('hide');

        }
        if (this.success === false) {
          this.btnDisable = false;
        }
      },
      (error) => {
        this.nao.go(100);
        this.btnDisable = false;
        // console.log('error', error);
      }
    )}

    cancelProblem(){
      $('#confirmation_modal').modal('hide');
    }
  }






// WEBPACK FOOTER //
// ./src/app/report-problem/report-problem.component.ts